import  { useState } from 'react';
import {  Root } from '../../types/dashboard';
import { formatAddress } from '../../tools/utils';
import { AccessControl } from '../../hooks/Helper/GlobalContext';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../components/Loader';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

interface ProfileCardProps {
    CandidateAccessControl?:string,
}

export const ProfileCard = ({CandidateAccessControl}: ProfileCardProps) => {

    const { contact, loading, error } = useSelector((state: RootState) => state.contact);
    const data = (contact || {}) as unknown as Root['data'];
    const [profilePictureLoading, setprofilePictureLoading] = useState(true);
console.log("DATA:", data);
    const address = (data?.Addresses?.length || 0) > 0 ? formatAddress(data.Addresses[0]) : null;
    const { t } = useTranslation();

    const handleImageLoaded = () => {
        setprofilePictureLoading(false);
      };

    return (
<div className="cco_row cco_row_0">
                            {loading ? (
                                <Loader />
                            ) : error ? (
                                <p>{error}</p>
                            ) : !contact || Object.keys(contact).length === 0 ? (
                                <Loader />
                            ) : (
                                <>
                                    <div className="cco_col cco_col_4">
                                        <div className="cco_img cco_img_1">
                                            <a
                                                className="cco_img_wrap"
                                                href={
                                                    data.ContactPhotoRequest || CandidateAccessControl===AccessControl.Suspended ? '#' : '/photo-management'
                                                }
                                             onClick={(e)=>{

                                        data.ContactPhotoRequest || CandidateAccessControl===AccessControl.Suspended?e.preventDefault():window.location.href='/photo-management'
                                            }}
                                            >
                                                {!data.ContactPhotoRequest && !data.myCCOPicture && (
                                                    <>
                                                        <img
                                                            src={"/Missing_Logo.png"}
                                                            alt=""
                                                        />
                                                        <div className="cco_img_icon">
                                                            <span className="cco_img_icon_path_0"></span>
                                                            <span className="cco_img_icon_path_1"></span>
                                                            <span className="cco_img_icon_path_2"></span>
                                                        </div>
                                                    </>
                                                )}
                                                <div
                                                    className={
                                                        data && data.ContactPhotoRequest
                                                            ? 'cco_img_caption_pending'
                                                            : 'cco_img_caption'
                                                    }
                                                >
                                                    {data.ContactPhotoRequest
                                                        ? t("dashboard.profileCard.pendingApproval")
                                                        : t("dashboard.profileCard.updatePhoto")}
                                                </div>
                                                <div
                                                    className={
                                                        data && data.ContactPhotoRequest
                                                            ? 'cco_img_caption_pending cco_img_caption_hover'
                                                            : 'cco_img_caption cco_img_caption_hover'
                                                    }
                                                >
                                                    {data.ContactPhotoRequest
                                                        ? t("dashboard.profileCard.pendingApproval")
                                                        : t("dashboard.profileCard.updatePhoto")}
                                                </div>

                                                {!data.ContactPhotoRequest|| data.myCCOPicture ? (
                                                    <>
                                                        {profilePictureLoading && (
                                                            <div style={{ marginTop: '30%' }}>
                                                                <Loader />
                                                            </div>
                                                        )}
                                                        <img
                                                            src={data && data.myCCOPicture}
                                                            onLoad={handleImageLoaded}
                                                            style={{
                                                                display: profilePictureLoading ? 'none' : 'block',
                                                            }}
                                                            alt="user profile picture"
                                                        />

                                                    </>
                                                ) : (
                                                    <>
                                                        <img
                                                              src={"/Missing_Logo.png"}
                                                            alt=""
                                                        />
                                                        <div className="cco_img_icon">
                                                            <span className="cco_img_icon_path_0"></span>
                                                            <span className="cco_img_icon_path_1"></span>
                                                            <span className="cco_img_icon_path_2"></span>
                                                        </div>
                                                        <div className="cco_img_caption">
                                                            {data.ContactPhotoRequest
                                                                ? t("dashboard.profileCard.pendingApproval")
                                                                : t("dashboard.profileCard.updatePhoto")}
                                                        </div>
                                                    </>
                                                )}
                                            </a>
                                        </div>
                                    </div>

                                    <div className="cco_col cco_col_12">
                                        <div className="cco_text cco_text_1">
                                            <div className="cco_text_inner">
                                                <h1>
                                                <strong>  {data.Name.FullName}</strong>
                                                    <span className="divider" />
                                                    <small>
                                                        {t('dashboard.profileCard.ccoId')} <strong>{data.SecondaryKeys[0].Key}</strong>
                                                    </small>
                                                </h1>
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )}
                        </div>
    );
};
